import React, { useState } from 'react'
import { MetricCard } from '../../Components/MetricCard'
import PieIcon from "../../Images/Graph.svg"
import UsersIcon from "../../Images/User.svg"
import PencilIcon from "../../Images/pencil-fill.svg";
import DeleteIcon from "../../Images/delete-bin-fill.svg";
import TeacherImg from "../../Images/teacherImg.png";
import CourseImg from "../../Images/course_title_placeholder.png";
import "./superAdminDash.css"
import Graph from '../../Components/Graph'
import Table from '../../Components/Table'
import { CustomSelect } from '../../Components/CustomSelect';
import AdminDashboard from './AdminDashboard';

const metrics = [
    { cardIcon: PieIcon, value: "4,000,000", userCount: "450", optionTitle: "This week", variant: "blue" },
    { cardIcon: UsersIcon, value: "14,000,000", userCount: "1,180", optionTitle: "This month", variant: "red" },
    { cardIcon: UsersIcon, value: "14,000,000", userCount: "1,180", optionTitle: "June", variant: "red" },
];

const courseColumns = [
    { Header: 'Courses List', accessor: 'courseList' },
    { Header: 'Number of Students', accessor: 'numberOfStudents' },
    { Header: 'Midterm Test Takers', accessor: 'midtermTestTakers' },
    { Header: 'Final Test Takers', accessor: 'finalTestTakers' },
    { Header: 'Purchased Courses', accessor: 'purchasedCourses' },
    { Header: 'Completed Courses', accessor: 'completedCourses' },
    { Header: 'Incomplete Courses', accessor: 'incompleteCourses' },
    { Header: 'Gross profit', accessor: 'grossProfit' },
];

const teachersListColumns = [
    { Header: 'Teacher Name', accessor: 'teacherName' },
    { Header: 'Start Date', accessor: 'startDate' },
    { Header: 'Topic', accessor: 'topic' },
    { Header: 'Midterm Result', accessor: 'midtermResult' },
    { Header: 'Final Result', accessor: 'finalResult' },
    { Header: 'Purchased Courses', accessor: 'purchasedCourses' },
    { Header: 'Status', accessor: 'status' },
];

const courseData = Array.from({ length: 105 }, (_, index) => ({
    id: index + 1,
    imgSrc: CourseImg,
    courseList: "Audit and Finance",
    numberOfStudents: "90",
    midtermTestTakers: "50",
    finalTestTakers: "20",
    purchasedCourses: "100",
    completedCourses: "32",
    incompleteCourses: "60",
    grossProfit: "22 000 000",
}));

const teachersListData = Array.from({ length: 105 }, (_, index) => ({
    id: index + 1,
    imgSrc: TeacherImg,
    teacherName: "Simon Khan",
    startDate: "12 Aug 2022 - 12:25 am",
    topic: "Audit and Finance",
    midtermResult: "92",
    finalResult: "92",
    purchasedCourses: "2",
    status: index % 2 === 0 ? "Completed" : "In-Progress",
}));

const SuperAdminDashboard = () => {

    const [data, setData] = useState(courseData);
    const [currentPage, setCurrentPage] = useState(1);
    const [tableTab, setTableTab] = useState("Courses");
    const rowsPerPage = 10;

    const startIndex = (currentPage - 1) * rowsPerPage;

    const changeRole = ((e) => {
        setTableTab(e.target.value)
    })


    return (
        <div>
            {/* <div className="cards-container">
                {metrics.map((metric, index) => (
                    <MetricCard
                        key={index}
                        cardIcon={metric.cardIcon}
                        value={metric.value}
                        userCount={metric.userCount}
                        optionTitle={metric.optionTitle}
                        variant={metric.variant}
                    />
                ))}
            </div>
            <Graph />
            <div className="tab-container">
                <div className='tab-header'>
                    <div className='tab-select'>
                        <CustomSelect
                            placeholder={"Courses"}
                            options={["Courses", "Teachers List"]}
                            onChange={(value) => changeRole(value)}
                            name={"role"}
                            customStyle={{ padding: "0" }}
                        />
                    </div>
                    <div className="edit-block">
                        <div className="icon-wrapper"><img src={PencilIcon} alt="" /></div>
                        <div className="icon-wrapper"><img src={DeleteIcon} alt="" /></div>
                    </div>
                </div>
                {tableTab === "Courses" ? <Table
                    columns={courseColumns}
                    data={data}
                    startIndex={startIndex}
                    rowsPerPage={rowsPerPage}
                    withLink={true}
                /> : <Table
                    columns={teachersListColumns}
                    data={teachersListData}
                    startIndex={startIndex}
                    rowsPerPage={rowsPerPage}
                    withLink={true}
                />}
            </div> */}
            <AdminDashboard />
        </div>
    )
}

export default SuperAdminDashboard
